import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { find, map, includes } from 'lodash'
import { filterPostsByTopicSlug, filterTrimesterPosts } from 'hello_baby/lib'
import GearView from 'hello_baby/components/gear-view'
import PregnancyView from 'hello_baby/components/pregnancy-view'
import PregnancyWeekByWeekView from 'hello_baby/components/pregnancy-week-by-week-view'
import ParentingView from 'hello_baby/components/parenting-view'
import SampleRegistriesView from 'hello_baby/components/sample-registries-view'
import PostTeaserList from 'hello_baby/components/post-teaser-list'
import Loader from 'components/Loader'
import { babylistUrl, helloBabyPostPath } from 'lib/urls'
import {
  getPosts,
  getSubTopics,
  getTopicDescriptionForSlug,
  getTopicPageTitleForSlug,
} from '../reducers'
import {
  GEAR_SLUG,
  PARENTING_SLUG,
  PREGNANCY_SLUG,
  PREGNANCY_WEEK_BY_WEEK_SLUG,
  SAMPLE_REGISTRIES_SLUG,
  FRIENDS_AND_FAMILY_SLUG,
} from '../constants'
import FriendsAndFamilyView from './friends-and-family-view/friends-and-family-view'
import HelloBabyMeta from './HelloBabyMeta'

class TopicView extends Component {
  renderTopic() {
    const { posts, slug } = this.props
    let filteredPosts = filterPostsByTopicSlug(posts, slug)

    switch (slug) {
      case GEAR_SLUG:
        return <GearView {...this.props} posts={filteredPosts} />
      case PARENTING_SLUG:
        return <ParentingView {...this.props} />
      case PREGNANCY_SLUG:
        return <PregnancyView {...this.props} />
      case FRIENDS_AND_FAMILY_SLUG:
        return <FriendsAndFamilyView {...this.props} />
      case PREGNANCY_WEEK_BY_WEEK_SLUG:
        return <PregnancyWeekByWeekView {...this.props} />
      case SAMPLE_REGISTRIES_SLUG:
        return <SampleRegistriesView {...this.props} />
      case 'first-trimester-of-pregnancy':
      case 'second-trimester-of-pregnancy':
      case 'third-trimester-of-pregnancy':
        filteredPosts = filterTrimesterPosts(posts, slug)
      case 'your-baby-week-by-week':
        filteredPosts = filterPostsByTopicSlug(posts, slug, {
          sortBy: 'slug',
          order: 'asc',
        })
      default:
        return <PostTeaserList {...this.props} posts={filteredPosts} />
    }
  }

  render() {
    const { posts, slug, topicDescription, topicPageTitle } = this.props

    return !posts ||
      !find(posts, (post) => includes(map(post.meta.topics, 'slug'), slug)) ? (
      <div
        style={{ minHeight: '100vh', position: 'relative', marginTop: '-11vh' }}
      >
        <Loader className="center-xy" />
      </div>
    ) : (
      <>
        <HelloBabyMeta
          canonical={babylistUrl(helloBabyPostPath(slug))}
          seoDescription={topicDescription}
          title={topicPageTitle}
        />
        {this.renderTopic()}
      </>
    )
  }
}

TopicView.propTypes = {
  emailUrls: PropTypes.object,
  posts: PropTypes.object,
  subTopics: PropTypes.array,
  slug: PropTypes.string,
  topicDescription: PropTypes.string,
  topicPageTitle: PropTypes.string,
}

const mapStateToProps = (state, ownProps) => ({
  posts: ownProps.posts || getPosts(state),
  subTopics: getSubTopics(state, ownProps.slug),
  topicDescription: getTopicDescriptionForSlug(ownProps.slug, state),
  topicPageTitle: getTopicPageTitleForSlug(ownProps.slug, state),
})

export default connect(mapStateToProps)(TopicView)
